import { indicatorHasValue } from "./indicator-has-value";
export var indicatorGroupsWithResults = function (items) {
  return items.filter(function (item) {
    return item.indicators && item.indicators.length && item.indicators.some(indicatorHasValue);
  });
};